<template>
  <div class="contact-container">
    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      label-width="192px"
      :label-position="$store.getters.isSP ? 'top' : 'left'"
      :hide-required-asterisk="true"
    >
      <el-form-item prop="title">
        <template v-slot:label>
          <g-form-label :label="$t('contactUs.contactUsTitle')" />
        </template>
        <el-input
          v-model="form.title"
          :placeholder="$t('contactUs.contactUsTitlePlaceholder')"
          :maxlength="200"
        />
      </el-form-item>
      <el-form-item prop="name">
        <template v-slot:label>
          <g-form-label :label="$t('contactUs.contactUsName')" />
        </template>
        <el-input
          v-model="form.name"
          :placeholder="
            $t('$.placeholderInput', [$t('contactUs.contactUsName')])
          "
          :maxlength="100"
        />
      </el-form-item>
      <el-form-item prop="mail">
        <template v-slot:label>
          <g-form-label :label="$t('contactUs.contactUsMail')" />
        </template>
        <el-input
          v-model="form.mail"
          :placeholder="
            $t('$.placeholderInput', [$t('contactUs.contactUsMail')])
          "
          :maxlength="100"
        />
      </el-form-item>
      <el-form-item prop="model">
        <template v-slot:label>
          <g-form-label :label="$t('contactUs.contactUsModelName')" />
        </template>
        <g-select
          v-model="form.model"
          :placeholder="
            $t('$.placeholderSelect', [$t('contactUs.contactUsModelName')])
          "
          :options="modelOptions"
          :title="$t('contactUs.contactUsModelName')"
        />
      </el-form-item>
      <el-form-item prop="details">
        <template v-slot:label>
          <g-form-label :label="$t('contactUs.contactUsContent')" />
        </template>
        <el-input
          type="textarea"
          v-model="form.details"
          :rows="3"
          :maxlength="900"
          :placeholder="
            $t('$.placeholderInput', [$t('contactUs.contactUsContent')])
          "
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div class="btn-wrapper">
      <el-button type="primary" :loading="loading" @click="handleClickBtn">
        {{ $t("contactUs.btnSend") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { httpSendContact } from "@/http/httpApi";
import { validateMail } from "@/utils";

export default {
  name: "contact-view",
  data() {
    return {
      loading: false,
      form: {
        title: "",
        name: "",
        mail: "",
        model: undefined,
        details: "",
      },
      modelOptions: [
        { value: 1, label: "iPhone" },
        { value: 2, label: "Android" },
        { value: 0, label: this.$t("contactUs.other") },
      ],
    };
  },
  computed: {
    formRules() {
      return {
        title: [
          {
            required: true,
            message: this.$t("contactUs.contactUsTitlePlaceholder"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("$.messageInputRequired", [
              this.$t("contactUs.contactUsName"),
            ]),
            trigger: "blur",
          },
        ],
        mail: [
          {
            required: true,
            message: this.$t("$.messageInputRequired", [
              this.$t("contactUs.contactUsMail"),
            ]),
            trigger: "blur",
          },
          { validator: validateMail.bind(this), trigger: "blur" },
        ],
        details: [
          {
            required: true,
            message: this.$t("$.messageInputRequired", [
              this.$t("contactUs.contactUsContent"),
            ]),
            trigger: "blur",
          },
        ],
        model: [
          {
            required: true,
            message: this.$t("$.messageSelectRequired", [
              this.$t("contactUs.contactUsModelName"),
            ]),
            trigger: "change",
          },
        ],
      };
    },
  },
  methods: {
    handleClickBtn() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          if (await this.sendContact()) {
            this.loading = false;
            this.$refs["form"].resetFields();
            this.$alert(
              this.$t("contactUs.msgSendSucceed"),
              this.$t("contactUs.msgSendSucceedTitle")
            );
            return;
          }
          this.loading = false;
        }
      });
    },
    async sendContact() {
      console.log(this.form);
      const res = await httpSendContact(this.form);
      if (res.code === 200) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-container {
  .el-select {
    width: 100%;
  }
}
</style>
